export function profileFormvalidations(value){

    let errors = {};
    if(!value.name){
        errors.name = 'Name is required';
    }
    if(!value.username){
        errors.username = 'Username is required';
    }
    if(!value.gender){
        errors.gender = 'Gender is required';
    }
    if(!value.email){
        errors.email = 'Email is required';
    }
    if(!value.phone){
        errors.phone = 'Phone is required';
    }
    if(!value.dob){
        errors.dob = 'Date of Birth is required';
    }
    if(!value.address){
        errors.address = 'Address is required';
    }
    if(!value.current_location){
        errors.current_location = 'Current Location is required';
    }
    return errors;


}